
export class ByteArrayUtils {

	public static Compare(a: Uint8Array, b: Uint8Array): number {

		for (var i = 0; i < a.length; ++i) {
			if (a[i] < b[i])
				return -1;
			else if (a[i] > b[i])
				return 1;
		}

		return 0;
	}

	public static ComputeHashCode(a: Uint8Array): number {
		// XOR successive 4-byte values

		var result = 0;

		var i = 0;
		while (i < a.length) {
			// Construct the next 4-byte value
			var value = 0;
			for (var j = 0; j < 4 && i < a.length; ++j) {
				value = ((value << 8) | a[i]);
				++i;
			}

			// XOR the 4-byte value with the result
			result ^= value;
		}

		return result;
	}

	public static Increment(a: Uint8Array): boolean {
		// 1. Find the least-significant byte that is < 255
		// 2. Increment it
		// 3. Zero out all less significant bytes
		for (var i = a.length - 1; i >= 0; --i) {
			if (a[i] < 255) {
				++a[i];
				for (var j = i + 1; j < a.length; ++j)
					a[j] = 0;
				return true;
			}
		}
		return false;
	}

	public static Decrement(a: Uint8Array): boolean {
		// 1. Find the least-significant byte that is > 0
		// 2. Decrement it
		// 3. Set all less significant bytes to 255
		for (var i = a.length - 1; i >= 0; --i) {
			if (a[i] > 0) {
				--a[i];
				for (var j = i + 1; j < a.length; ++j)
					a[j] = 255;
				return true;
			}
		}
		return false;
	}

	public static SetMostSignificantBits(a: Uint8Array, bitsToSet: number) {

		var completeBytes = bitsToSet / 8;
		var extraBits = (bitsToSet % 8);

		var i = 0;

		while (i < completeBytes)
			a[i++] = 255;

		if (extraBits > 0)
			a[i] |= ByteArrayUtils.MostSignificantPartialBytes[extraBits];
	}

	private static MostSignificantPartialBytes: Uint8Array = new Uint8Array([
		0x00,	// 0 bits
		0x80,	// 1 bit
		0xc0,	// 2 bits
		0xe0,	// 3 bits
		0xf0,	// 4 bits
		0xf8,	// 5 bits
		0xfc,	// 6 bits
		0xfe,	// 7 bits
	]);

	public static SetLeastSignificantBits(a: Uint8Array, bitsToSet: number) {
		var completeBytes = bitsToSet / 8;
		var extraBits = (bitsToSet % 8);

		var i = 0;
		var index = a.length - 1;

		while (i++ < completeBytes)
			a[index--] = 255;

		if (extraBits > 0)
			a[index] |= ByteArrayUtils.LeastSignificantPartialBytes[extraBits];
	}

	private static LeastSignificantPartialBytes: Uint8Array = new Uint8Array([
		0x00,	// 0 bits
		0x01,	// 1 bit
		0x03,	// 2 bits
		0x07,	// 3 bits
		0x0f,	// 4 bits
		0x1f,	// 5 bits
		0x3f,	// 6 bits
		0x7f,	// 7 bits
	]);

	public static CountLeastSignificantZeroBits(a: Uint8Array): number {
		var result = 0;

		for (var i = a.length - 1; i >= 0; --i) {
			var b = a[i];
			if (b == 0) {
				result += 8;
			}
			else {
				var mask = 0x01;
				for (var j = 0; j < 8; ++j) {
					if ((mask & b) > 0) {
						// Found first one bit, so stop counting
						break;
					}
					else {
						++result;
						mask <<= 1;
					}
				}

				break;
			}
		}

		return result;
	}

	public static BytesToHexString(bytes: Uint8Array): string {
		let hex: string = bytes.reduce((t, x) => t + this.PadStart(x.toString(16), 2, '0'), '');
		return hex;
	}

	private static PadStart(s: string, targetLength: number, fillChar: string): string {
		while (s.length < targetLength) {
			s = (fillChar + s);
		}

		return s;
	}

	public static HexStringToBytes(hex: string): Uint8Array {
		var result = new Uint8Array(hex.length / 2);

		let idx = 0;
		while (hex.length >= 2) {
			result[idx++] = parseInt(hex.substring(0, 2), 16);
			hex = hex.substring(2, hex.length);
		}

		return result;
	}

}